export const SET_ALL_DATA_OF_CONTACT_STATE = "SET_ALL_DATA_OF_CONTACT_STATE";
export const SET_SEARCHED_DATA_OF_CONTACT_STATE = "SET_SEARCHED_DATA_OF_CONTACT_STATE";